import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import ReactApexChart from 'react-apexcharts';

import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';

import { apiService } from '../../../../services/ApiService';

import Card from '../../../../components/Card/Card';
import CardBody from '../../../../components/Card/CardBody';
import RangeSelect from './RangeSelect';
import { createBarChartOptions } from './chartOptions';
import { FilterIcon } from '../../../../components/Icons/Icons';

const saleTypeOptions = {
  '': 'All Sales',
  FUEL_ONLY: 'Fuel Only',
  RETAIL_ONLY: 'Retail Only',
  FUEL_AND_RETAIL: 'Fuel & Retail',
};

function PosTransactionsChart() {
  const [saleType, setSaleType] = useState('');
  const [period, setPeriod] = useState('year');
  const { data: chart = [], isLoading } = useQuery({
    queryKey: ['pos-transactions-chart', period, saleType],
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: async () => {
      const params = {
        range: period,
      };

      if (saleType) {
        params.saleType = saleType;
      }

      const response = await apiService.getStatsPosTxCount(params);

      return response.data;
    },
  });

  const handleSaleType = (type) => {
    setSaleType(type);
  };

  const series = useMemo(
    () => [
      {
        name: 'Transactions',
        data: chart.map((item) => item.count),
      },
    ],
    [chart],
  );

  const options = useMemo(
    () =>
      createBarChartOptions({
        color: '#FFB91B',
        categories: chart.map((i) => new Date(i.date).toISOString()),
        yFormatter: (v) => v.toFixed(0),
        tooltipFormatter: (v) => `${v} transaction${v === 1 ? '' : 's'}`,
      }),
    [chart],
  );

  return (
    <Card minH={301} padding="24px 16px 12px 16px" w="100%">
      <Flex justifyContent="center" mb="12px">
        <Text variant="title-lg">POS Transactions</Text>
      </Flex>
      <RangeSelect period={period} setPeriod={setPeriod} />
      <Flex align="center" mb="12px">
        <Menu variant="filter">
          <MenuButton
            as={Button}
            leftIcon={<FilterIcon color="white" fontSize="24px" />}
            variant="secondary-md"
            color="white"
            w="220px"
            px="24px !important"
          >
            {saleTypeOptions[saleType]}
          </MenuButton>

          <MenuList className="context-menu">
            {Object.entries(saleTypeOptions).map(([value, label]) => (
              <MenuItem key={value} onClick={() => handleSaleType(value)}>
                {label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Flex>
      <CardBody w="100%" padding="0">
        <Box w="100%">
          {isLoading ? (
            <Flex justifyContent="center" alignItems="center" height="315px">
              <Text>Loading chart data...</Text>
            </Flex>
          ) : (
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={300}
              className="full-width-members-dashboard-chart"
            />
          )}
        </Box>
      </CardBody>
    </Card>
  );
}

export default PosTransactionsChart;
